var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB1ConsumptionHotWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 42h28v4H3V15.24L27.52 0 52 15.24V33h-4V17.46L27.52 4.73 7 17.46V42zm7-6h4v-5.91l-2-2.17-2 2.17V36zm14 0h4V21.09l-2-2.17-2 2.17V36zm-7 0h4V25.09l-2-2.17-2 2.17V36zm20 2v8h15v-4h17v-4H41zm0 12h32v9h-7v-3H56v20H41V50zm3.69 16.87a8 8 0 003.45 6.6 6.77 6.77 0 01-.8-3.32 5.82 5.82 0 011.55-4.27 5.822 5.822 0 011.55 4.27 6.78 6.78 0 01-.8 3.32 8 8 0 003.45-6.6c0-3.06-1.38-5.33-4.2-7.78-2.62 2.09-4.2 4.72-4.2 7.78zM35 17.09V36h4V17.09l-2-2.17-2 2.17z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B1_Consumption_hot_water.1ef87299.svg";
export { SvgB1ConsumptionHotWater as ReactComponent };